import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'

import SectionHeader from 'components_new/molecules/SectionHeader'

import DataStatus from 'components_new/organisms/DataStatus'

import { getParsedDate, useParsedWeekday } from 'utils/dateParser'
import { useTranslation } from 'language/translator'

interface KeyMetricsHeaderProps {
  sx?: SxProps
}

const KeyMetricsHeader = (props: KeyMetricsHeaderProps) => {
  const { sx } = props

  const { t, lang } = useTranslation()

  const date = getParsedDate(new Date(), lang)
  const weekday = useParsedWeekday()

  return (
    <>
      <Box
        sx={{ display: 'flex', gap: 2, justifyContent: 'space-between', ...sx }}
      >
        <SectionHeader
          body={
            <>
              {t('key_metrics', 'updated_stats_for') + ' '}
              <b>
                {weekday} {date}
              </b>
              .
            </>
          }
          size="large"
          sx={sx}
          title={t('key_metrics', 'key_metrics')}
        />

        <DataStatus />
      </Box>
    </>
  )
}

export default KeyMetricsHeader
